"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.TestMembershipPoints__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_contract",
                type: "address"
            },
            {
                internalType: "address",
                name: "_address",
                type: "address"
            },
            {
                internalType: "int256",
                name: "amount",
                type: "int256"
            },
        ],
        name: "modify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5061022d806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063dfe6686b14610030575b600080fd5b61004a6004803603810190610045919061015d565b61004c565b005b60008390508073ffffffffffffffffffffffffffffffffffffffff1663c4e6a47284846040518363ffffffff1660e01b815260040161008c9291906101ce565b600060405180830381600087803b1580156100a657600080fd5b505af11580156100ba573d6000803e3d6000fd5b5050505050505050565b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006100f4826100c9565b9050919050565b610104816100e9565b811461010f57600080fd5b50565b600081359050610121816100fb565b92915050565b6000819050919050565b61013a81610127565b811461014557600080fd5b50565b60008135905061015781610131565b92915050565b600080600060608486031215610176576101756100c4565b5b600061018486828701610112565b935050602061019586828701610112565b92505060406101a686828701610148565b9150509250925092565b6101b9816100e9565b82525050565b6101c881610127565b82525050565b60006040820190506101e360008301856101b0565b6101f060208301846101bf565b939250505056fea2646970667358221220e2df4ca5cc9c6242d68de22b1c239f9ed6134fb9d00c55562570dbf8151afc4864736f6c634300080d0033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var TestMembershipPoints__factory = /** @class */ (function (_super) {
    __extends(TestMembershipPoints__factory, _super);
    function TestMembershipPoints__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    TestMembershipPoints__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    TestMembershipPoints__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    TestMembershipPoints__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TestMembershipPoints__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TestMembershipPoints__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    TestMembershipPoints__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    TestMembershipPoints__factory.bytecode = _bytecode;
    TestMembershipPoints__factory.abi = _abi;
    return TestMembershipPoints__factory;
}(ethers_1.ContractFactory));
exports.TestMembershipPoints__factory = TestMembershipPoints__factory;
